@use "../../styles/breakpoint.module.scss" as *;

.root {
    display: flex;
    justify-content: space-between;
    gap: var(--spacer-40);
    padding-block: var(--spacer-80);
    border-bottom: 1px solid var(--gray-700);

    :root[data-design-version="v2026"] & {
        grid-column: 2 / span 10;
        padding-inline: 0;
        border-bottom: none;

        @media ($below-mobile) {
            grid-column: 1 / span 10;
        }
    }

    @media ($below-mobile) {
        flex-direction: column;
        align-items: center;
        gap: var(--spacer-40);
        padding-block: var(--spacer-40);
    }
}

.text {
    flex-shrink: 0;
    max-width: 438px;

    @media ($below-mobile) {
        text-align: center;
    }
}

.heading {
    font: var(--font-h-48);
    margin: 0 0 var(--spacer-16) 0;
}

.description {
    p {
        font: var(--font-p-16);
        letter-spacing: 0.03em;
        color: var(--off-white);
    }
}

.form {
    flex: 1;
    max-width: 553px;
    width: 100%;
}

.fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacer-24);

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.field {
    width: 100%;
    margin: 0;

    input,
    button {
        width: 100%;
        color: inherit;
        border-bottom-color: var(--off-white);
        letter-spacing: 0.03em;
    }

    input::placeholder {
        color: var(--gray-500);
    }

    [data-placeholder] {
        color: var(--gray-500);
    }

    button svg {
        width: 16px;
        height: 16px;
    }
}

.fieldFullWidth {
    composes: field;
    grid-column: 1 / -1;
}

.submit {
    margin-top: var(--spacer-40);
}
